/* eslint-disable @typescript-eslint/no-explicit-any */
const formatDate = (dateString: string) => {
  const date = new Date(dateString);

  // Date formatting options
  const dateOptions: Intl.DateTimeFormatOptions = {
    day: "numeric",
    month: "long",
    year: "numeric",
  };

  // Time formatting options (12-hour format with AM/PM)
  const timeOptions: Intl.DateTimeFormatOptions = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  const formattedDate = date.toLocaleDateString("en-US", dateOptions);
  const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

  return `${formattedDate} at ${formattedTime}`;
};
export default formatDate;
